module.exports = __webpack_public_path__ + "img/DE04090.be0ae0dd.png";